export const nataliaSarnowska = {
    'meta': {
        'title': 'Pedagog specjalny, Psychoterapeuta Natalia Sarnowska COLLIGO',
        'description': 'Pedagog specjalny, psychoterapeuta w trakcie szkolenia. Od lat wspieram osoby z wyzwaniami rozwojowymi (szczególnie ze spektrum autyzmu) i ich rodziny.'
    },
    'url': {
        'address': '/torun/zespol/pedagog-psychoterapeuta-natalia-sarnowska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/natalia-sarnowska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Pedagog, Psychoterapeuta'
        }
    }
}